// pager defaults
var pageSize = 25;
var currentPage = 1;
var pageCount = 1;
var itemSelector;

function createPager(mode, selector) {
    itemSelector = selector;
    // get number of videos
    var videoCount = jQuery(selector).length;
    // get initial page count
    pageCount = videoCount/pageSize;
    // if there is a remainder and pages are > 1; get lowest(floor) integer and add one, else just round the page count
    pageCount = (videoCount%pageSize > 0 && pageCount > 1) ? Math.round(Math.floor(pageCount) + 1) : Math.round(pageCount);
    if (pageCount > 1) {
        // check modes; we're just getting fancy here!
        switch(mode) {
            case 'classic':
                // create previous, next and numeric buttons with ID's, classes, and events
                jQuery("#pager").append('<a id="previous" href="javascript:void(0)" onclick="showPrevious();" style="visibility: hidden"><img src="../images/previouspage.png" alt="Go to Previous Page" style="border: none; position: relative; top: 3px; margin-right: 3px;" /></a>&nbsp;');
                for (i=1;i<=pageCount;i++) { $("#pager").append('<a class="page' + i + '" href="javascript:void(0)" onclick="showPage(' + i + ',' + pageCount + ');">' + i + '</a>&nbsp;'); }
                jQuery("#pager").append('&nbsp;<a id="next" href="javascript:void(0)" onclick="showNext();"><img  src="../images/nextpage.png" alt="Go to Next Page" style="border: none; position: relative; top: 3px; margin-left: 3px;" /></a>');
                break;
            case 'input':
                // create previous, next and input box for specific page
                jQuery("#pager").css({'text-align':'right'});
                jQuery("#pager").append('<a id="first" href="javascript:void(0)" onclick="showPage(1);" style="visibility: hidden"><img src="../images/firstpage.png" alt="Go to First Page" style="border: none; position: relative; top: 3px; margin-right: 3px;" /></a>');
                jQuery("#pager").append('<a id="previous" href="javascript:void(0)" onclick="showPrevious();" style="visibility: hidden"><img src="../images/previouspage.png" alt="Go to Previous Page" style="border: none; position: relative; top: 3px; margin-right: 3px;" /></a>&nbsp;');
                jQuery("#pager").append('<input id="inputPage" aria-label="Current Page" type="text" value="' + currentPage + '" style="width: 20px; border: 1px solid #999" onchange="showPage(this.value, ' + pageCount + ');" /> of ' + pageCount)
                jQuery("#pager").append('&nbsp;<a id="next" href="javascript:void(0)" onclick="showNext();"><img src="../images/nextpage.png" alt="Go to Next Page" style="border: none; position: relative; top: 3px; margin-left: 3px;" /></a>');
                jQuery("#pager").append('<a id="last" href="javascript:void(0)" onclick="showPage(' + pageCount + ');"><img src="../images/lastpage.png" alt="Go to Last Page" style="border: none; position: relative; top: 3px; margin-left: 3px;" /></a>');
                break;
        }
        jQuery("#pager").show();
    }
    else {
        jQuery("#pager").hide();
    }
}

function showPage(index) {
    var startIndex;
    // if index is out of range; set to last page
    if (index < 1 || index > pageCount) {index = pageCount;}
    // if page input exists; set to new value
    if (jQuery('#inputPage')) {jQuery('#inputPage').val(index);}
    // remove all selected classes
    jQuery("#pager a").removeClass("pageSelected");
    // apply selected class to current page link
    jQuery(".page" + index).addClass('pageSelected');
    // set current page
    currentPage = index;
    // hide all cells
    jQuery(itemSelector).hide();
    // if first page
    if (index == 1) {
        // set previous, next visiblity
        jQuery('#previous').css({'visibility':'hidden'});
        jQuery('#next').css({'visibility':'visible'});
        jQuery('#first').css({'visibility':'hidden'});
        jQuery('#last').css({'visibility':'visible'});
        // show first page
        jQuery(itemSelector + ":lt(" + pageSize + ")").show();
    }
    // if last page
    else if (index == pageCount) {
        // set previous, next visiblity
        jQuery('#previous').css({'visibility':'visible'});
        jQuery('#next').css({'visibility':'hidden'});
        jQuery('#first').css({'visibility':'visible'});
        jQuery('#last').css({'visibility':'hidden'});
        // figure out which video to start showing; first on the page
        startIndex = ((index-1)*pageSize-1);
        // show each video after that
        jQuery(itemSelector + ":gt(" + startIndex + ")").show();
    }
    // if index event (link click or input change)
    else {
        // set previous, next visiblity
        jQuery('#previous').css({'visibility':'visible'});
        jQuery('#next').css({'visibility':'visible'});
        jQuery('#first').css({'visibility':'visible'});
        jQuery('#last').css({'visibility':'visible'});
        // figure out which video to start showing; first on the page
        startIndex = ((index-1)*pageSize) - 1;
        // figure out where to re-hide videos that come after the current page
        var hideAfterIndex = (startIndex + pageSize);
        // hide and show the appropriate videos
        jQuery(itemSelector + ":gt(" + startIndex + ")").show();
        jQuery(itemSelector + ":gt(" + hideAfterIndex + ")").hide();
    }
}

function showNext() {
    var newPage = currentPage + 1;
    showPage(newPage);
    currentPage = newPage;
}

function showPrevious() {
    var newPage = currentPage - 1;
    showPage(newPage);
    currentPage = newPage;
}